<template>
  <div class="out-list">
    <template v-for="item in labelConfig.outList">
      <el-tooltip v-if="!!item.tooltipContent" effect="dark" :content="item.tooltipContent" placement="top">
        <span class="label-item" :style="{ color: item.color || '#fff', background: item.background || '#52C41A' }">{{
          item.text }}</span>
      </el-tooltip>
      <span v-else class="label-item"
        :style="{ color: item.color || '#fff', background: item.background || '#52C41A' }">{{
          item.text }}</span>
    </template>
    <el-popover v-if="labelConfig.inList.length > 0" trigger="hover" placement="top-end"
      popper-class="label-list-in-list-popover">
      <div class="in-list">
        <template v-for="item in labelConfig.inList">
          <el-tooltip v-if="!!item.tooltipContent" effect="dark" :content="item.tooltipContent" placement="top">
            <span class="label-item"
              :style="{ color: item.color || '#fff', background: item.background || '#52C41A' }">{{
                item.text }}</span>
          </el-tooltip>
          <span v-else class="label-item"
            :style="{ color: item.color || '#fff', background: item.background || '#52C41A' }">{{
              item.text }}</span>
        </template>
      </div>
      <template #reference>
        <div class="ellipsis">...</div>
      </template>
    </el-popover>
  </div>
</template>

<script>
import { showInventoryText as showText, showInventoryTip, getByteLen } from "@/utils/common";

export default {
  name: "LabelList",
  props: ['item'],
  computed: {
    labelConfig: function () {
      const addLabelColorMap = {
        "追溯码": { color: '#fff', background: '#52C41A' },
        "基药": { color: '#1D2088', background: '#EDF3FF' },
        "医保甲类": { color: '#E60036', background: '#FFEDEF' },
        "医保乙类": { color: '#FD8E17', background: '#FFF7E6' },
        "医保丙类": { color: '#13C2C2', background: '#E6FFFB' }
      }
      const addLabelArr = (Array.isArray(this.item.labelList) ? this.item.labelList : []).map(text => {
        const { color, background } = addLabelColorMap[text] || {}
        return { text, color, background, show: true }
      })
      const list = [{
        text: '秒杀',
        background: '#ea5506',
        tooltipContent: "该产品为秒杀产品",
        show: this.item.productActivityPriceStrategyFlag === 1 &&
          this.item.productActivityPriceStrategyDetail &&
          this.item.productActivityPriceStrategyDetail.canSaleAmount
      },
      {
        text: '特价',
        background: '#d61518',
        tooltipContent: "新用户特价产品",
        show: this.item.inventoryList[0].newCustomerPriceFlag &&
          this.item.inventoryList[0].newCustomerPriceFlag == '1'
      },
      {
        text: this.item.inventoryList[0].deliveryTime || "24H",
        background: this.item.inventoryList[0].deliveryTime === '24'
          ? '#009944'
          : '#1D2088',
        show: true
      },
      {
        text: this.item.inventoryList[0].priceTitle,
        background: '#4d5aaf',
        show: this.item.inventoryList[0].priceTitle &&
          this.item.inventoryList[0].priceTitle !== ''
      },
      ...addLabelArr,
      {
        text: '促销',
        background: '#d61518',
        tooltipContent: showInventoryTip(this.item),
        show: showText(this.item)
      }, {
        text: '近效期',
        background: '#9f10f9',
        tooltipContent: "该产品为近效期产品",
        show: this.item.inventoryList[0].nearDateFlag
      },
      {
        text: this.item.minDiscountTicket?.name,
        background: '#5064eb',
        show: (this.item.productActivityPriceStrategyFlag !== 1 ||
          this.item.productActivityPriceStrategyDetail.canSaleAmount ===
          0) &&
          this.item.minDiscountTicket &&
          this.item.minDiscountTicket.name !== ''
      }]
      const showList = list.filter(el => !!el.show)
      const MaxWidth = 206
      const widthList = showList.map(el => getByteLen(el.text) * 6 + 10)
      const totalWidth = widthList.reduce((pre, cur) => pre + cur, 0)
      if (totalWidth <= MaxWidth) {
        return { outList: showList, inList: [] }
      }
      const EllipsisWidth = 18
      let splitIndex = -1, tWidth = 0
      for (let i = 0; i < showList.length; i++) {
        if (tWidth + widthList[i] > MaxWidth - EllipsisWidth) {
          splitIndex = i
          break
        }
        tWidth += widthList[i]
      }
      return { outList: showList.slice(0, splitIndex), inList: showList.slice(splitIndex) }
    }
  }
}
</script>

<style lang="scss" scoped>
.out-list {
  width: 100%;
  display: flex;
  align-items: center;

  .ellipsis {
    width: 18px;
    font-size: 12px;
    line-height: 1;
    color: '#152488'
  }
}

.label-item {
  padding: 2px 3px;
  margin-right: 4px;
  font-size: 12px;
  line-height: 1;
}

.in-list {
  display: flex;
  align-items: center;
}

:global(.label-list-in-list-popover) {
  padding: 8px 6px;
}
</style>